import { render, staticRenderFns } from "./Circle5.vue?vue&type=template&id=40ce1896&scoped=true&"
import script from "./Circle5.vue?vue&type=script&lang=js&"
export * from "./Circle5.vue?vue&type=script&lang=js&"
import style0 from "./Circle5.vue?vue&type=style&index=0&id=40ce1896&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ce1896",
  null
  
)

export default component.exports